var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.709 15.4693C14.709 17.6623 12.866 19.4473 10.6009 19.4473L6.09827 19.4473C3.83867 19.4473 2.00031 17.6667 2.00031 15.4782L2.00031 5.53232C2.00031 3.33843 3.84236 1.55253 6.10751 1.55253L10.6101 1.55253C12.8697 1.55253 14.709 3.33395 14.709 5.52337L14.709 6.36443L14.709 15.4693Z",
    fill: "#E9A5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88759 10.9886L9.54309 13.5914C9.81755 13.8598 10.2592 13.8598 10.5328 13.5896C10.8054 13.3194 10.8045 12.8837 10.5309 12.6152L9.07688 11.1899L18.3002 11.1899C18.6865 11.1899 19 10.8812 19 10.5001C19 10.1198 18.6865 9.81202 18.3002 9.81202L9.07688 9.81202L10.531 8.38581C10.8045 8.11739 10.8054 7.68165 10.5328 7.41144C10.3955 7.27634 10.2165 7.20834 10.0366 7.20834C9.85844 7.20834 9.67941 7.27634 9.54309 7.40965L6.88759 10.0124C6.75582 10.1422 6.6813 10.3175 6.6813 10.5001C6.6813 10.6835 6.75582 10.8589 6.88759 10.9886Z",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.295572011cd2b241474c7a7605f8fd46.svg";
export { ForwardRef as ReactComponent };